import { isNumber, isString, isUndefined } from "lodash";
import { theme } from "uikit";

import { Order } from "../../../../../../../services";
import { DateFns } from "../../../../../../../utils/DateFns";

function formatDuration(milliseconds: number): string {
	if (!isNumber(milliseconds) || Number.isNaN(milliseconds)) return "";

	const sign = Math.sign(milliseconds);
	const abs = Math.abs(milliseconds);

	const seconds = Math.floor((abs / 1e3) % 60);
	const minutes = Math.floor((abs / (1e3 * 60)) % 60);
	const hours = Math.floor((abs / (1e3 * 60 * 60)) % 24);
	const days = Math.floor(abs / (1e3 * 60 * 60 * 24));

	const formatted = `${days ? `${days}Д ` : ""}${String(hours).padStart(
		2,
		"0",
	)}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
	return sign < 0 ? `-${formatted}` : formatted;
}

const cellProcessing = (
	item: Order.Model,
	dateFns: DateFns,
	currentTime: Date, // <-- правильно типизирован
) => {
	const lastReceivedOrder =
		item?.additionalFields?.transfer?.lastReceivedOrder;
	const fromTransferExecutor = lastReceivedOrder?.executorToOrder?.at(0);

	const primaryTime =
		item.executorToOrder?.[0]?.additionalFields?.arrivalTime;
	const fallbackTime = fromTransferExecutor?.additionalFields?.arrivalTime;
	const defaultTime = item.orderDate;

	let executorArrivalTimestamp: number | undefined;
	if (isNumber(primaryTime)) executorArrivalTimestamp = primaryTime;
	else if (isNumber(fallbackTime)) executorArrivalTimestamp = fallbackTime;
	else if (isString(primaryTime))
		executorArrivalTimestamp = Number(primaryTime);
	else if (isString(fallbackTime))
		executorArrivalTimestamp = Number(fallbackTime);
	else if (isString(defaultTime)) {
		const parsedDate = new Date(defaultTime);
		if (!Number.isNaN(parsedDate.getTime())) {
			executorArrivalTimestamp = parsedDate.getTime();
		}
	}

	const withClients =
		!isUndefined(item.executingStages?.with_clients?.timestamp) ||
		!isUndefined(
			lastReceivedOrder?.executingStages?.with_clients?.timestamp,
		);

	let timeLeft: number | undefined;
	if (!isUndefined(executorArrivalTimestamp)) {
		timeLeft = dateFns.getMillisecondsDiff(
			executorArrivalTimestamp,
			currentTime.getTime(),
		);
	}

	const content = isUndefined(timeLeft) ? "" : formatDuration(timeLeft);

	let backgroundColor: string | undefined;
	if (withClients) {
		backgroundColor = "#4CAF50";
	} else if (!isUndefined(timeLeft) && timeLeft < 0) {
		backgroundColor = "#E8807F";
	}

	const textColor =
		!isUndefined(timeLeft) && timeLeft < 0 ? theme.colors.white : undefined;

	return { content, backgroundColor, textColor };
};

export default cellProcessing;
